import { getUrl } from '@/config/api.routes';
import axios from 'axios';

export default {
  namespaced: true,
  state: {
    generatedFAQ: [],
    isOpenState: false,
    messageList: [],
  },
  getters: {},
  mutations: {
    UPDATE_WINDOW_STATE(state, isOpenState) {
      state.isOpenState = isOpenState;
    },
    UPDATE_MESSAGES(state, newMessageList) {
      state.messageList = newMessageList;
    },
    CLEAR_MESSAGES(state) {
      state.messageList = [];
    },
  },
  actions: {
    generateFAQ(_, payload) {
      return axios.post(`${getUrl('genAi.generate_faq')}`, {
        query: payload?.query,
        past_conversations: payload?.pastConversations,
        session_id: payload?.sessionId,
      },
      ).then(data => {
        return data.data;
      });
    },

    updateWindowState({ commit }, isOpenState) {
      commit('UPDATE_WINDOW_STATE', isOpenState);
      if (!isOpenState) { // clear message on close
        commit('CLEAR_MESSAGES');
      }
    },

    updateMessages({ commit }, newMessageList) {
      commit('UPDATE_MESSAGES', newMessageList);
    },

    async sendFeedback(_, params) {
      const [id, action] = params;
      return axios.put(`${getUrl('genAi.generate_faq')}/${id}/vote`, {action: action});
    },
  },
};
